import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import { getLocalStorageInt, setLocalStorageTimestamp } from "@universityofmaryland/web-utilities-library/storage";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { CreateAlertText } from "./elements/text.js";
import { CreateCloseButton } from "./elements/closeButton.js";
import { BREAKPOINTS } from "./globals.js";
const { MEDIUM } = BREAKPOINTS;
const DEFAULT_HIDE_TIME = 30;
const ALERT_LOCAL_STORAGE_KEY = "umd-alert-site-time";
const shouldShow = (props) => {
  const { daysToHide } = props;
  const now = (/* @__PURE__ */ new Date()).getTime();
  const millisecondsPerDay = 24 * 60 * 60 * 1e3;
  const lastClosedTime = getLocalStorageInt({
    key: ALERT_LOCAL_STORAGE_KEY
  });
  if (!lastClosedTime) return false;
  const daysUntilAlertDisplay = daysToHide ? parseInt(daysToHide) : DEFAULT_HIDE_TIME;
  const futureTimeStamp = lastClosedTime + millisecondsPerDay * daysUntilAlertDisplay;
  const futureTime = new Date(futureTimeStamp).getTime();
  return futureTime > now;
};
const createLock = (props) => {
  const { isThemeDark } = props;
  const textModel = CreateAlertText(props);
  return new ElementBuilder().styled(layout.space.horizontal.larger).withChild(textModel).withStyles({
    element: {
      width: "100%"
    },
    subElement: {
      color: theme.foreground(isThemeDark),
      maxWidth: token.spacing.maxWidth.large
    }
  }).build();
};
const createCloseButton = () => CreateCloseButton({
  targetSelector: ".alert-site-declaration",
  onBeforeClose: () => setLocalStorageTimestamp({ key: ALERT_LOCAL_STORAGE_KEY })
});
const createContainer = (props) => {
  const lockElement = createLock(props);
  const closeButtonElement = createCloseButton();
  const children = [lockElement, closeButtonElement].filter(
    Boolean
  );
  return new ElementBuilder().withClassName("alert-site-container").withChildren(...children).withStyles({
    element: {
      display: "flex",
      position: "relative",
      padding: `${token.spacing.lg} 0`,
      gap: token.spacing.lg,
      backgroundColor: token.color.gold,
      borderLeft: `4px solid ${token.color.red}`,
      [`@container (min-width: ${MEDIUM}px)`]: {
        borderLeft: `8px solid ${token.color.red}`,
        paddingRight: token.spacing["2xl"]
      }
    }
  }).build();
};
const createWrapper = (container) => new ElementBuilder().withClassName("alert-site-declaration").withChild(container).withStyles({
  element: {
    containerType: "inline-size"
  }
}).build();
const createCompositeAlertSite = (props) => {
  const containerModel = createContainer(props);
  const declarationModel = createWrapper(containerModel);
  if (shouldShow(props)) {
    declarationModel.element.style.display = "none";
  }
  return declarationModel;
};
export {
  createCompositeAlertSite
};
//# sourceMappingURL=site.js.map
